import {h, Fragment} from "preact"
import { useFacets, useAppState, useProductFilters } from "@nosto/preact";
import Facet from "./Facet";
import RangeFacet from "./RangeFacet";
import Icon from "./elements/Icon";
import SelectedFilters from "./SelectedFilters";

function ToggleSidebarButton({ className, label }) {
  return (
    <label
      className={`ns-close-sidebar ns-absolute ns-d-block ns-text-align-right ns-align-items-center ns-clickable ns-font-3 ${className}`}
      for={label}
    >
      <Icon name="close" />
    </label>
  );
}

export default function SidebarAside({ label }) {
  const { loading, facets } = useFacets();
  const { query, response, pageType } = useAppState();
  const { removeAll } = useProductFilters();
  const isCategory = pageType == "category";
  let isMobile = window.innerWidth < 769;

  return facets?.length > 0 ? (
    <>
      <label
        class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none"
        for={label}
      />
      <div
        class={`ns-sidebar-wrapper ns-aside-wrapper ns-d-none ns-align-items-center ${label}`}
        style={loading ? "opacity: 0.3;" : ""}
      >
        <div class="ns-sidebar-content ns-relative ns-background-white ns-h-100 ns-mr-0 ns-mr-md-auto">
          <div class="ns-sidebar-content-header">
            <div class="ns-sidebar-main-title">Filters</div>
            <ToggleSidebarButton label={label} />
          </div>
          <div class="ns-sidebar-inner">
            <div class="ns-sidebar-menu">
              <ul class="ns-list-unstyled ns-m-0 ns-d-flex ns-align-items-center">
                {/*isCategory && ( <SelectedFilters />)*/}
                {facets?.map((facet) => {
                  switch (facet.type) {
                    case "terms":
                      return <Facet facet={facet} />;
                    case "stats":
                      return <RangeFacet facet={facet} />;
                    default:
                      return null;
                  }
                })}
              </ul>
            </div>
          </div>
          <div class="ns-sidebar-actions">
            <button
              class="ns-clear-btn"
              onClick={() => {
                removeAll();
              }}
            >
              Clear all
            </button>
            <button
              class="ns-apply-btn"
              onClick={() => {
                document
                  .querySelector(`.ns-aside-wrapper.${label} .ns-close-sidebar`)
                  .click();
              }}
            >
              Apply filters
            </button>
          </div>
        </div>
      </div>
    </>
  ) : (
    ""
  );
}
